"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToBasketPopupTile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const common_types_1 = require("@as-react/common-types");
const andes_react_1 = require("@yonderland/andes-react");
const usePriceProps_1 = require("../../../hooks/usePriceProps");
const IMAGE_SIZE = {
    mobile: { width: 88, height: 130 },
    tablet: { width: 64, height: 96 },
};
const AddToBasketPopupTile = ({ brand, description, image, productType, title, enablePriceReference, product, }) => {
    var _a;
    const priceInformation = product
        ? {
            hasDiscount: Boolean(product.productHasDiscount),
            prices: ((_a = product.prices) === null || _a === void 0 ? void 0 : _a.SELL)
                ? product.prices
                : {
                    SELL: { original: product.price, priceState: 'NOW' },
                    STD: { original: product.previousPrice || product.price, priceState: 'WAS' },
                    LOWEST: { original: product.lowestPrice },
                },
        }
        : undefined;
    const priceProps = (0, usePriceProps_1.usePriceProps)({
        priceInformation,
        enablePriceReference,
        dynamicSavingsInformation: {
            productDiscountAmount: product === null || product === void 0 ? void 0 : product.productDiscountAmount,
            productDiscountPercentage: product === null || product === void 0 ? void 0 : product.productDiscountPercentage,
        },
    });
    return ((0, jsx_runtime_1.jsxs)(cotopaxi_1.ProductTile, { variant: "horizontal", product: { image, brand, title, alt: title }, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Area, { area: "primary", children: (0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Image, { width: IMAGE_SIZE.mobile.width, height: IMAGE_SIZE.mobile.height, containerOptions: {
                        mobile: {
                            spacing: { marginRight: 1.5 },
                            width: IMAGE_SIZE.mobile.width,
                            height: IMAGE_SIZE.mobile.height,
                        },
                        tablet: {
                            spacing: { marginRight: 3 },
                            width: IMAGE_SIZE.tablet.width,
                            height: IMAGE_SIZE.tablet.height,
                        },
                    } }) }), (0, jsx_runtime_1.jsxs)(cotopaxi_1.ProductTile.Area, { area: "secondary", children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Title, { emphasizeTitle: productType === common_types_1.ProductTypes.E_VOUCHER, brandOnTheSameLine: true, containerOptions: {
                            mobile: { spacing: { marginBottom: productType === common_types_1.ProductTypes.E_VOUCHER ? 0 : 0.5 } },
                            tablet: { spacing: { marginBottom: 1 } },
                        } }), Boolean((productType === common_types_1.ProductTypes.PRODUCT || productType === common_types_1.ProductTypes.E_VOUCHER) && description) && ((0, jsx_runtime_1.jsx)(andes_react_1.Box, { paddingBlockEnd: {
                            xs: '0.5',
                            md: productType === common_types_1.ProductTypes.E_VOUCHER ? '0.5' : '4',
                        }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { inline: true, size: cotopaxi_1.TextSize.SMALL, color: cotopaxi_1.TextColor.SUBTLE, children: description }) })), priceProps && Boolean(priceProps.priceActual) && (0, jsx_runtime_1.jsx)(andes_react_1.Price, Object.assign({}, priceProps))] })] }));
};
exports.AddToBasketPopupTile = AddToBasketPopupTile;
